import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import assign from '../../_helpers/assign.js';
import withLengthOptions from '../_withlengthoptions.js';
import checkAddedItems from '../_processrendering/checkbeforechange.js';
// creates methods: push, unshift, push_, unshift_
export default function createAddingMethod(name, hasOptions) {
  return function pseudoNativeMethod() {
    var _this = this;
    var selfDef = syncFields(this);
    var itemMediator = selfDef.itemMediator;
    // +hasOptions is converted to 0 or 1 depending on its value (false/true)
    var argsLength = Math.max(arguments.length - +hasOptions, 0);
    var args = Array(argsLength);
    var givenEventOptions = hasOptions ? arguments[arguments.length - 1] : null;
    var useMediator = typeof itemMediator === 'function' && !(givenEventOptions != null && givenEventOptions.skipItemMediator);
    var isPush = name === 'push';
    var length = this.length;
    // if no arguments are passed
    if (!argsLength) {
      return length;
    }
    // convert arguments to array and call item mediator on every item if it's possible
    for (var i = 0; i < argsLength; i++) {
      var arg = arguments[i];
      if (useMediator) {
        var index = isPush ? i + length : i;
        args[i] = itemMediator(arg, index);
      } else {
        args[i] = arg;
      }
    }
    checkAddedItems(this, selfDef, args, givenEventOptions);
    if (isPush) {
      // insert new items to the end of array
      for (var _i = 0; _i < argsLength; _i++) {
        this[length + _i] = args[_i];
      }
    } else {
      // move current items to new indexes; a hole stays a hole, as in the native method
      for (var _i2 = length - 1; _i2 >= 0; _i2--) {
        if (_i2 in this) {
          this[argsLength + _i2] = this[_i2];
        } else {
          delete this[argsLength + _i2];
        }
      }
      // insert new items to the begin of array
      for (var _i3 = 0; _i3 < argsLength; _i3++) {
        this[_i3] = args[_i3];
      }
    }
    // update length
    length += argsLength;
    withLengthOptions(this, givenEventOptions, function () {
      _this.length = length;
    });
    var eventOptions = {
      method: name,
      self: this,
      added: args,
      removed: []
    };
    // extend event options by custom event options if they are given
    if (hasOptions) {
      if (givenEventOptions && typeof givenEventOptions === 'object') {
        assign(eventOptions, givenEventOptions);
      }
    }
    reportModified(this, eventOptions);
    return length;
  };
}